let firebaseCache = null;
const AUTH_DOMAIN_OVERRIDE_APP_NAME = "__liftflow_auth_domain_override__";

function waitForFirebaseGlobal() {
  return new Promise((resolve, reject) => {
    const deadline = Date.now() + 10000;

    const tick = () => {
      if (window.firebase?.apps?.length) {
        resolve(window.firebase);
        return;
      }
      if (Date.now() > deadline) {
        reject(new Error("Firebase SDK 로딩에 실패했습니다"));
        return;
      }
      setTimeout(tick, 60);
    };

    tick();
  });
}

function normalizeHost(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  try {
    const candidate = raw.includes("://") ? raw : `https://${raw}`;
    return new URL(candidate).hostname.toLowerCase();
  } catch (_) {
    return raw
      .replace(/^https?:\/\//i, "")
      .replace(/\/.*$/, "")
      .toLowerCase();
  }
}

function isLocalHost(host) {
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

function isFirebaseManagedHostingHost(host) {
  return host.endsWith(".web.app") || host.endsWith(".firebaseapp.com");
}

function resolveFirebaseApp(firebase) {
  const defaultApp = firebase.app();
  const currentHost = normalizeHost(window.location?.hostname);
  const authDomainHost = normalizeHost(defaultApp?.options?.authDomain);

  // Mobile Safari blocks cross-site redirect auth more aggressively, but
  // only use same-host authDomain on Firebase-managed hosting domains.
  // Custom domains need separate OAuth redirect registration and can
  // otherwise trigger redirect_uri_mismatch.
  if (
    !currentHost ||
    isLocalHost(currentHost) ||
    !window.isSecureContext ||
    currentHost === authDomainHost ||
    !isFirebaseManagedHostingHost(currentHost)
  ) {
    return defaultApp;
  }

  const existingOverrideApp = firebase.apps.find((entry) => entry?.name === AUTH_DOMAIN_OVERRIDE_APP_NAME);
  if (existingOverrideApp) {
    return existingOverrideApp;
  }

  return firebase.initializeApp(
    {
      ...defaultApp.options,
      authDomain: currentHost,
    },
    AUTH_DOMAIN_OVERRIDE_APP_NAME,
  );
}

export async function getFirebaseClient() {
  if (firebaseCache) {
    return firebaseCache;
  }

  const firebase = await waitForFirebaseGlobal();
  const app = resolveFirebaseApp(firebase);
  firebaseCache = {
    firebase,
    app,
    auth: app.auth(),
    db: app.database(),
  };
  return firebaseCache;
}
